import { render, staticRenderFns } from "./CbrUpdatesFilters.vue?vue&type=template&id=23ff60a0&lang=pug&"
import script from "./CbrUpdatesFilters.vue?vue&type=script&lang=js&"
export * from "./CbrUpdatesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports